document.addEventListener('DOMContentLoaded', () => {
  const storageKey = 'sativus-seasonal-reopening-signup';

  document.querySelectorAll('[data-seasonal-reopening-banner]').forEach((banner) => {
    const form = banner.querySelector('#SeasonalReopeningSignup');
    const details = banner.querySelector('.seasonal-reopening-banner__details');
    const success = banner.querySelector('[data-seasonal-reopening-success]');
    const formContainer = banner.querySelector('[data-seasonal-reopening-form]');
    const returnPath = banner.dataset.returnPath;

    if (form && returnPath) {
      form.addEventListener('submit', () => {
        window.sessionStorage.setItem(storageKey, returnPath);
      });
    }

    if (
      success &&
      formContainer &&
      details &&
      window.sessionStorage.getItem(storageKey) === window.location.pathname
    ) {
      window.sessionStorage.removeItem(storageKey);
      formContainer.hidden = true;
      success.hidden = false;
      details.open = true;

      window.setTimeout(() => {
        details.open = false;
        success.hidden = true;
        formContainer.hidden = false;
      }, 6000);
    }
  });
});
